import {
  Button,
  CloseButton,
  Grid,
  Heading,
  Modal,
  Spinner,
  Text,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { MasteryLevelService } from "../../../services/MasteryLevelService";

const DefaultRatingScaleModal = ({
  open,
  setOpen,
  ratingScale,
  setUpdateMappings,
}) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);

  const handleDefaultSet = () => {
    setSubmitting(true);
    MasteryLevelService.setDefaultRatingMap(ratingScale.id)
      .then(() => {
        setOpen(false);
        setUpdateMappings(true);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal open={open} label={t("masteryLevels.defaultModal")}>
      <Modal.Header>
        <Grid hAlign="space-between">
          <Grid.Row>
            <Grid.Col>
              <Heading level="h2" as="h1">
                {t("masteryLevels.institutionalDefault")}
              </Heading>
            </Grid.Col>
            <Grid.Col width="auto">
              <CloseButton
                size="small"
                screenReaderLabel={t("global.close")}
                onClick={() => setOpen(false)}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </Modal.Header>
      <Modal.Body>
        <Text>
          {t("masteryLevels.defaultConfirmationOne")}
          {ratingScale.title} {t("masteryLevels.defaultConfirmationTwo")}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button margin="0 small" onClick={() => setOpen(false)}>
          {t("global.cancel")}
        </Button>
        <Button
          color="primary"
          onClick={handleDefaultSet}
          disabled={submitting}
        >
          {submitting ? (
            <Spinner size="x-small" renderTitle={t("global.pleaseWait")} />
          ) : (
            t("dialogYesNo.yes")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DefaultRatingScaleModal;
